<script>
  // Перенос GhostButton из lib/ui.tsx.
  export let block = false;
  export let size = 'md';
  export let disabled = false;
  export let style = undefined;
  let className = '';
  export { className as class };
</script>

<button class={'ui-btn ui-btn-ghost' + (block ? ' block' : '') + (size === 'sm' ? ' sm' : '') + (className ? ' ' + className : '')} {disabled} {style} on:click><slot /></button>
